import * as React from "react";
import Panel from "../../Panel";
import styles from "./styles.module.css";
import { FilterProp } from "@/types/index";
const FilterOverlay: React.FC<{
	onClick: (evt: any) => void;
	filterProps: FilterProp[];
}> = ({ onClick, filterProps }) => {
	const list = () => {
		return filterProps.map((filterProp, index) => {
			let localChange = (evt: any) => {
				filterProp.toggleFilter(evt.target.value);
			};

			return (
				<Panel
					key={index}
					title={filterProp.title}
					filters={filterProp.filters}
					onChange={localChange}
				/>
			);
		});
	};

	return (
		<div className={styles.overlay}>
			<div className={`${styles.show_deals} p-3`}>
				<div className="text-center">
					<button
						className="button button__gradient button__override"
						type="button"
						name="close"
						onClick={onClick}
					>
						Show Deals
					</button>
				</div>
			</div>
			<div className="container">
				<div className="mt-4"></div>
				{list()}
			</div>
		</div>
	);
};

export default FilterOverlay;
